import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AddStudent from "./AddStudent";

const summaryCardStyle = {
  flex: 1,
  minWidth: 180,
  background: "#f8fafc",
  borderRadius: 12,
  padding: 24,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
  margin: 8,
};

// Filters UI component (multi-select dropdowns)
function FiltersBar({
  reasonOpen,
  setReasonOpen,
  supportOpen,
  setSupportOpen,
  gradeOpen,
  setGradeOpen,
  selectedReasons,
  setSelectedReasons,
  selectedSupports,
  setSelectedSupports,
  selectedGrades,
  setSelectedGrades,
  gradeOptions,
}) {
  const reasonRef = React.useRef(null);
  const supportRef = React.useRef(null);
  const gradeRef = React.useRef(null);

  // Close on outside click
  React.useEffect(() => {
    function onClick(e) {
      if (
        reasonOpen &&
        reasonRef.current &&
        !reasonRef.current.contains(e.target)
      ) {
        setReasonOpen(false);
      }
      if (
        supportOpen &&
        supportRef.current &&
        !supportRef.current.contains(e.target)
      ) {
        setSupportOpen(false);
      }
      if (
        gradeOpen &&
        gradeRef.current &&
        !gradeRef.current.contains(e.target)
      ) {
        setGradeOpen(false);
      }
    }
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [
    reasonOpen,
    supportOpen,
    gradeOpen,
    setReasonOpen,
    setSupportOpen,
    setGradeOpen,
  ]);

  const toggleReason = (opt) => {
    setSelectedReasons((prev) =>
      prev.includes(opt) ? prev.filter((r) => r !== opt) : [...prev, opt]
    );
  };

  const toggleSupport = (opt) => {
    setSelectedSupports((prev) =>
      prev.includes(opt) ? prev.filter((r) => r !== opt) : [...prev, opt]
    );
  };
  const toggleGrade = (opt) => {
    setSelectedGrades((prev) =>
      prev.includes(opt) ? prev.filter((r) => r !== opt) : [...prev, opt]
    );
  };

  const clearAll = () => {
    setSelectedReasons([]);
    setSelectedSupports([]);
    setSelectedGrades([]);
  };

  return (
    <div
      style={{ display: "flex", gap: 12, marginBottom: 10, flexWrap: "wrap" }}
    >
      {/* Reason filter */}
      <div style={{ position: "relative" }} ref={reasonRef}>
        <button
          type="button"
          onClick={() => setReasonOpen((o) => !o)}
          style={{
            background: "#fff",
            border: "1px solid #cbd5e1",
            borderRadius: 6,
            padding: "10px 12px",
            cursor: "pointer",
            minWidth: 180,
          }}
        >
          Reason:{" "}
          {selectedReasons.length === 0
            ? "All"
            : `${selectedReasons.length} selected`}
          <span style={{ marginLeft: 8, color: "#64748b" }}>▾</span>
        </button>
        {reasonOpen && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 6px)",
              left: 0,
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: 8,
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              padding: 8,
              zIndex: 20,
              width: 240,
              maxHeight: 260,
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {REASONS_WITH_UNKNOWN.map((opt) => (
              <label
                key={opt}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: 6,
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedReasons.includes(opt)}
                  onChange={() => toggleReason(opt)}
                />
                <span>{opt}</span>
              </label>
            ))}
          </div>
        )}
      </div>

      {/* Support Status filter */}
      <div style={{ position: "relative" }} ref={supportRef}>
        <button
          type="button"
          onClick={() => setSupportOpen((o) => !o)}
          style={{
            background: "#fff",
            border: "1px solid #cbd5e1",
            borderRadius: 6,
            padding: "10px 12px",
            cursor: "pointer",
            minWidth: 220,
          }}
        >
          Support:{" "}
          {selectedSupports.length === 0
            ? "All"
            : `${selectedSupports.length} selected`}
          <span style={{ marginLeft: 8, color: "#64748b" }}>▾</span>
        </button>
        {supportOpen && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 6px)",
              left: 0,
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: 8,
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              padding: 8,
              zIndex: 20,
              width: 260,
              maxHeight: 260,
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {SUPPORTS.map((opt) => (
              <label
                key={opt}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: 6,
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedSupports.includes(opt)}
                  onChange={() => toggleSupport(opt)}
                />
                <span>{opt}</span>
              </label>
            ))}
          </div>
        )}
      </div>

      {/* Grade filter */}
      <div style={{ position: "relative" }} ref={gradeRef}>
        <button
          type="button"
          onClick={() => setGradeOpen((o) => !o)}
          style={{
            background: "#fff",
            border: "1px solid #cbd5e1",
            borderRadius: 6,
            padding: "10px 12px",
            cursor: "pointer",
            minWidth: 160,
          }}
        >
          Grade:{" "}
          {selectedGrades.length === 0
            ? "All"
            : `${selectedGrades.length} selected`}
          <span style={{ marginLeft: 8, color: "#64748b" }}>▾</span>
        </button>
        {gradeOpen && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 6px)",
              left: 0,
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: 8,
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              padding: 8,
              zIndex: 20,
              width: 200,
              maxHeight: 260,
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {gradeOptions.map((opt) => (
              <label
                key={opt}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: 6,
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedGrades.includes(opt)}
                  onChange={() => toggleGrade(opt)}
                />
                <span>{opt}</span>
              </label>
            ))}
          </div>
        )}
      </div>

      {/* Clear filters */}
      {(selectedReasons.length > 0 || selectedSupports.length > 0) && (
        <button
          type="button"
          onClick={clearAll}
          style={{
            background: "none",
            border: "none",
            color: "#2563eb",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Clear filters
        </button>
      )}
    </div>
  );
}

// Shared option sets
const REASONS = [
  "Academic",
  "Behavioral",
  "Social/Emotional",
  "Family-related",
  "Attendance",
];
const REASONS_WITH_UNKNOWN = [...REASONS, "Unknown"];
const SUPPORTS = [
  "IEP",
  "504",
  "RTI Tier 1",
  "RTI Tier 2",
  "RTI Tier 3",
  "Counseling only",
  "N/A",
];
const GRADE_UNKNOWN = "Unknown";

const Dashboard = () => {
  const [search, setSearch] = useState("");
  const tab = "table";
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const studentsPerPage = 6;
  const [showAddStudent, setShowAddStudent] = useState(false);
  const [noteCounts, setNoteCounts] = useState({}); // studentId -> total notes
  const [notes, setNotes] = useState([]); // all notes fetched for school/my scope
  const [sharedWithMe, setSharedWithMe] = useState([]); // derived: notes shared with current user
  const [sectionTab, setSectionTab] = useState("search"); // 'search' | 'shared'
  const [sharedPage, setSharedPage] = useState(1);
  const SHARED_PER_PAGE = 6;
  const [, forceRerender] = useState(false); // toggle to force re-render on read changes
  // const [showAddStudent, setShowAddStudent] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  // Filter UI state
  const [reasonOpen, setReasonOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);
  const [gradeOpen, setGradeOpen] = useState(false);
  const [selectedReasons, setSelectedReasons] = useState([]); // strings from REASONS_WITH_UNKNOWN
  const [selectedSupports, setSelectedSupports] = useState([]); // strings from SUPPORTS
  const [selectedGrades, setSelectedGrades] = useState([]); // strings for grade values
  const navigate = useNavigate();

  // --- Fetch students ---
  const fetchStudents = async () => {
    setLoading(true);
    setError("");
    try {
      const token = localStorage.getItem("token");
      const apiUrl = process.env.REACT_APP_API_URL || "";
      const res = await fetch(`${apiUrl.replace(/\/$/, "")}/students`, {
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
      if (!res.ok) throw new Error("Failed to fetch students");
      const data = await res.json();
      setStudents(data.students || []);
      setFilteredStudents(data.students || []);
    } catch (err) {
      setError(err.message || "Error loading students");
    } finally {
      setLoading(false);
    }
  };

  // --- Fetch profile ---
  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = process.env.REACT_APP_API_URL || "";
      const res = await fetch(`${apiUrl.replace(/\/$/, "")}/me`, {
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
      if (!res.ok) throw new Error("Failed to fetch user profile");
      const data = await res.json();
      setUserProfile(data);
    } catch {
      setUserProfile(null);
    }
  };

  useEffect(() => {
    fetchStudents();
    fetchProfile();
    // Fetch notes and compute counts per student
    (async () => {
      try {
        const token = localStorage.getItem("token");
        const apiUrl = process.env.REACT_APP_API_URL || "";
        const res = await fetch(`${apiUrl.replace(/\/$/, "")}/notes`, {
          headers: { Authorization: token ? `Bearer ${token}` : "" },
        });
        if (!res.ok) throw new Error("Failed to fetch notes");
        const data = await res.json();
        const allNotes = Array.isArray(data.notes) ? data.notes : [];
        setNotes(allNotes);
        const counts = {};
        for (const n of allNotes) {
          if (!n || !n.studentId) continue;
          counts[n.studentId] = (counts[n.studentId] || 0) + 1;
        }
        setNoteCounts(counts);
      } catch (e) {
        // Leave counts empty on error; UI will show 0
        setNoteCounts({});
        setNotes([]);
      }
    })();
  }, []);

  // Derive "Shared with me" once we have user profile and notes
  useEffect(() => {
    if (!userProfile || !userProfile.email) {
      setSharedWithMe([]);
      return;
    }
    const myEmail = userProfile.email;
    const filtered = (notes || [])
      .filter(
        (n) => Array.isArray(n.sharedWith) && n.sharedWith.includes(myEmail)
      )
      .filter((n) => n.ownerEmail !== myEmail)
      .filter((n) => !n.deleted)
      .sort((a, b) => {
        const ad = new Date(a.consentTimestamp || a.createdAt || 0).getTime();
        const bd = new Date(b.consentTimestamp || b.createdAt || 0).getTime();
        return bd - ad; // most recent first
      });
    setSharedWithMe(filtered);
  }, [userProfile, notes]);

  // Reset/clamp shared pagination when data or tab changes
  useEffect(() => {
    if (sectionTab === "shared") setSharedPage(1);
  }, [sectionTab]);
  useEffect(() => {
    const total = Math.max(
      1,
      Math.ceil((sharedWithMe?.length || 0) / SHARED_PER_PAGE)
    );
    if (sharedPage > total) setSharedPage(total);
  }, [sharedWithMe, sharedPage]);

  const totalSharedPages = Math.max(
    1,
    Math.ceil((sharedWithMe?.length || 0) / SHARED_PER_PAGE)
  );
  const sharedStartIdx = (sharedPage - 1) * SHARED_PER_PAGE;
  const paginatedShared = sharedWithMe.slice(
    sharedStartIdx,
    sharedStartIdx + SHARED_PER_PAGE
  );

  // Local read tracking (frontend-only). Keyed by user and noteId.
  const isNoteRead = (noteId) => {
    const email = userProfile?.email || "unknown";
    try {
      return localStorage.getItem(`noteRead:${email}:${noteId}`) === "1";
    } catch {
      return false;
    }
  };
  const markNoteRead = (noteId) => {
    const email = userProfile?.email || "unknown";
    try {
      localStorage.setItem(`noteRead:${email}:${noteId}`, "1");
      forceRerender((b) => !b);
    } catch {}
  };

  // Map studentId -> display name for quick lookup
  const studentNameById = React.useMemo(() => {
    const map = {};
    for (const s of students) {
      const name = `${s.firstName || s.name || ""} ${s.lastName || ""}`.trim();
      map[s.studentId] = name || s.studentId;
    }
    return map;
  }, [students]);

  // Helpers to normalize values
  const normalizeReason = (val) => {
    const r = (val || "").trim();
    if (!r) return "Unknown";
    return REASONS.includes(r) ? r : "Unknown";
  };
  const normalizeSupports = (val) => {
    // Always return an array, map missing to ["N/A"]
    if (Array.isArray(val)) {
      return val.length ? val : ["N/A"];
    }
    if (typeof val === "string" && val.trim()) {
      return [val.trim()];
    }
    return ["N/A"];
  };
  const normalizeGrade = (val) => {
    if (val === 0) return "0";
    if (val === null || val === undefined) return GRADE_UNKNOWN;
    const g = String(val).trim();
    return g ? g : GRADE_UNKNOWN;
  };

  // Derive last meeting display from meetings array
  const getLastMeeting = (s) => {
    const arr = Array.isArray(s?.meetings) ? s.meetings : [];
    if (!arr.length) return "-";
    const dates = arr
      .map((v) => new Date(v))
      .filter((d) => d && !isNaN(d.getTime()))
      .sort((a, b) => b.getTime() - a.getTime());
    if (!dates.length) return "-";
    return dates[0].toLocaleDateString();
  };

  // Derive grade options from students
  const gradeOptions = React.useMemo(() => {
    const set = new Set();
    let hasUnknown = false;
    for (const s of students) {
      const g = normalizeGrade(s.grade);
      if (g === GRADE_UNKNOWN) hasUnknown = true;
      else set.add(g);
    }
    const arr = Array.from(set);
    arr.sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" })
    );
    return hasUnknown ? [GRADE_UNKNOWN, ...arr] : arr;
  }, [students]);

  // --- Search + Filters ---
  useEffect(() => {
    // base if no inputs
    const q = search.toLowerCase().trim();

    const filtered = students.filter((s) => {
      // Search matching
      let matchesSearch = true;
      if (q) {
        const gradeStr = s.grade ? String(s.grade).toLowerCase() : "";
        const first = s.firstName?.toLowerCase() || "";
        const last = s.lastName?.toLowerCase() || "";
        const name = s.name?.toLowerCase() || "";
        const id = s.studentId ? String(s.studentId).toLowerCase() : "";

        const isNumeric = /^\d+$/.test(q);
        if (isNumeric) {
          matchesSearch = gradeStr === q;
        } else {
          matchesSearch =
            first.includes(q) ||
            last.includes(q) ||
            name.includes(q) ||
            id.includes(q) ||
            gradeStr.includes(q);
        }
      }

      if (!matchesSearch) return false;

      // Reasons filter (single value per student)
      const studentReason = normalizeReason(s.referredReason);
      const matchesReason =
        selectedReasons.length === 0 || selectedReasons.includes(studentReason);
      if (!matchesReason) return false;

      // Supports filter (multi value per student)
      const studentSupports = normalizeSupports(s.studentSupportStatus);
      const matchesSupport =
        selectedSupports.length === 0 ||
        studentSupports.some((st) => selectedSupports.includes(st));
      if (!matchesSupport) return false;

      // Grade filter (single value per student)
      const g = normalizeGrade(s.grade);
      const matchesGrade =
        selectedGrades.length === 0 || selectedGrades.includes(g);
      if (!matchesGrade) return false;

      return true;
    });

    setFilteredStudents(filtered);
    setPage(1);
  }, [search, students, selectedReasons, selectedSupports, selectedGrades]);

  // --- Logout handler ---
  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    const apiUrl = process.env.REACT_APP_API_URL || "";
    try {
      await fetch(`${apiUrl.replace(/\/$/, "")}/logout`, {
        method: "POST",
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
    } catch {}
    localStorage.removeItem("token");
    navigate("/login");
  };

  const userRole = userProfile?.role || null;
  const displayName = userProfile?.firstName || "Counselor";

  // Pagination slice
  const paginated = filteredStudents.slice(
    (page - 1) * studentsPerPage,
    page * studentsPerPage
  );

  return (
    <div style={{ background: "#f3f4f6", minHeight: "100vh" }}>
      {/* Top nav */}
      <nav
        style={{
          background: "linear-gradient(90deg, #23395d 60%, #2d4a7a 100%)",
          color: "#fff",
          padding: "0 0 0 32px",
          display: "flex",
          alignItems: "center",
          height: 64,
          fontWeight: 500,
          fontSize: 18,
          letterSpacing: 0.5,
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        }}
      >
        <span style={{ fontWeight: 700, fontSize: 22, marginRight: 40 }}>
          COUNSELOR NOTES
        </span>
        <button
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            textDecoration: "none",
            marginRight: 32,
            font: "inherit",
            cursor: "pointer",
          }}
          onClick={() => navigate("/dashboard")}
        >
          Home
        </button>
        <button
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            textDecoration: "none",
            marginRight: 32,
            font: "inherit",
            cursor: "pointer",
          }}
          onClick={() => navigate("/support-plans")}
        >
          Support Plans
        </button>
        <button
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            textDecoration: "none",
            marginRight: 32,
            font: "inherit",
            cursor: "pointer",
          }}
          onClick={() => navigate("/analysis")}
        >
          Analysis
        </button>
        <div
          style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
        >
          <button
            onClick={() => setShowAddStudent(true)}
            style={{
              background: "none",
              border: "1px solid rgba(255,255,255,0.6)",
              color: "#fff",
              marginRight: 12,
              fontWeight: 600,
              fontSize: 14,
              borderRadius: 6,
              padding: "6px 10px",
              cursor: "pointer",
            }}
          >
            Add Student
          </button>
          {userRole === "admin" && (
            <button
              onClick={() => navigate("/add-schools")}
              style={{
                background: "none",
                border: "1px solid rgba(255,255,255,0.6)",
                color: "#fff",
                marginRight: 12,
                fontWeight: 600,
                fontSize: 14,
                borderRadius: 6,
                padding: "6px 10px",
                cursor: "pointer",
              }}
            >
              Add Schools
            </button>
          )}
          {(userRole === "admin" ||
            userRole === "districtAdmin" ||
            userRole === "auditor") && (
            <button
              onClick={() => navigate("/admin-tools")}
              style={{
                background: "none",
                border: "1px solid rgba(255,255,255,0.6)",
                color: "#fff",
                marginRight: 12,
                fontWeight: 600,
                fontSize: 14,
                borderRadius: 6,
                padding: "6px 10px",
                cursor: "pointer",
              }}
            >
              Admin Tools
            </button>
          )}
          <button
            onClick={handleLogout}
            style={{
              background: "#fff",
              color: "#23395d",
              border: "none",
              borderRadius: 6,
              fontWeight: 700,
              fontSize: 16,
              padding: "8px 22px",
              cursor: "pointer",
              marginRight: 24,
            }}
          >
            Log Out
          </button>
        </div>
      </nav>

      {/* Add Student Modal */}
      {showAddStudent && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.25)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setShowAddStudent(false)}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              boxShadow: "0 4px 32px rgba(0,0,0,0.13)",
              padding: 24,
              minWidth: 340,
              maxWidth: 520,
              width: "90vw",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowAddStudent(false)}
              style={{
                position: "absolute",
                top: 12,
                right: 16,
                background: "none",
                border: "none",
                fontSize: 22,
                color: "#64748b",
                cursor: "pointer",
              }}
              aria-label="Close"
            >
              ×
            </button>
            <AddStudent
              onStudentAdded={async () => {
                setShowAddStudent(false);
                await fetchStudents();
                // Reset search/page to make it easy to find the new student (optional)
                // setSearch("");
                // setPage(1);
              }}
            />
          </div>
        </div>
      )}

      <div style={{ maxWidth: 900, margin: "0 auto", padding: 32 }}>
        <h1 style={{ fontSize: 32, fontWeight: 600, margin: "32px 0 24px 0" }}>
          Welcome, {displayName}
        </h1>

        {/* Summary cards */}
        <div style={{ display: "flex", gap: 16, marginBottom: 32 }}>
          <div style={summaryCardStyle}>
            <div style={{ fontSize: 36 }}>👥</div>
            <div style={{ fontSize: 28, fontWeight: 700 }}>
              {loading ? "..." : students.length}
            </div>
            <div style={{ color: "#334155" }}>Total Students</div>
          </div>
        </div>

        {/* Section Tabs: Search Students | Shared with me */}
        <div
          style={{
            display: "flex",
            gap: 24,
            margin: "8px 0 12px 0",
            alignItems: "center",
          }}
        >
          <span
            role="button"
            tabIndex={0}
            onClick={() => setSectionTab("search")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") setSectionTab("search");
            }}
            style={{
              borderBottom:
                sectionTab === "search" ? "3px solid #2563eb" : "none",
              color: sectionTab === "search" ? "#2563eb" : "#222",
              paddingBottom: 6,
              cursor: "pointer",
              fontWeight: 500,
            }}
          >
            Search Students
          </span>
          <span
            role="button"
            tabIndex={0}
            onClick={() => setSectionTab("shared")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") setSectionTab("shared");
            }}
            style={{
              borderBottom:
                sectionTab === "shared" ? "3px solid #2563eb" : "none",
              color: sectionTab === "shared" ? "#2563eb" : "#222",
              paddingBottom: 6,
              cursor: "pointer",
              fontWeight: 500,
            }}
          >
            Shared with me
          </span>
        </div>

        {sectionTab === "shared" ? (
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
              marginTop: 0,
              marginBottom: 24,
              overflow: "hidden",
            }}
          >
            <div
              style={{ padding: 16, background: "#f1f5f9", fontWeight: 600 }}
            >
              Shared with me
            </div>
            {sharedWithMe.length === 0 ? (
              <div style={{ padding: 16, color: "#64748b" }}>
                No notes have been shared with you yet.
              </div>
            ) : (
              <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                {paginatedShared.map((n, idx) => (
                  <li
                    key={n.noteId}
                    onClick={() => {
                      markNoteRead(n.noteId);
                      navigate(`/students/${n.studentId}?openNote=${n.noteId}`);
                    }}
                    style={{
                      padding: 14,
                      borderTop: idx === 0 ? "none" : "1px solid #e5e7eb",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontWeight: 600, color: "#0f172a" }}>
                        {n.topic && String(n.topic).trim()
                          ? n.topic
                          : "No topic"}
                      </div>
                      <div
                        style={{ fontSize: 13, color: "#64748b", marginTop: 4 }}
                      >
                        Student: {studentNameById[n.studentId] || n.studentId}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        marginLeft: 12,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {!isNoteRead(n.noteId) && (
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            color: "#b91c1c",
                            fontSize: 12,
                            fontWeight: 700,
                          }}
                        >
                          <span
                            style={{
                              width: 8,
                              height: 8,
                              background: "#ef4444",
                              borderRadius: "50%",
                              display: "inline-block",
                            }}
                          />
                          Unread
                        </span>
                      )}
                      <span style={{ fontSize: 12, color: "#475569" }}>
                        {new Date(
                          n.consentTimestamp || n.createdAt
                        ).toLocaleString()}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            )}
            {sharedWithMe.length > SHARED_PER_PAGE && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 16,
                  padding: 12,
                  borderTop: sharedWithMe.length ? "1px solid #e5e7eb" : "none",
                }}
              >
                <button
                  onClick={() => setSharedPage((p) => Math.max(1, p - 1))}
                  disabled={sharedPage === 1}
                  style={{
                    padding: "8px 18px",
                    borderRadius: 6,
                    border: "none",
                    background: sharedPage === 1 ? "#e5e7eb" : "#2563eb",
                    color: sharedPage === 1 ? "#888" : "#fff",
                  }}
                >
                  ← Prev
                </button>
                <span>
                  Page {sharedPage} of {totalSharedPages}
                </span>
                <button
                  onClick={() =>
                    setSharedPage((p) => Math.min(totalSharedPages, p + 1))
                  }
                  disabled={sharedPage === totalSharedPages}
                  style={{
                    padding: "8px 18px",
                    borderRadius: 6,
                    border: "none",
                    background:
                      sharedPage === totalSharedPages ? "#e5e7eb" : "#2563eb",
                    color: sharedPage === totalSharedPages ? "#888" : "#fff",
                  }}
                >
                  Next →
                </button>
              </div>
            )}
          </div>
        ) : (
          <>
            {/* Search bar */}
            <div
              style={{ display: "flex", alignItems: "center", marginBottom: 8 }}
            >
              <input
                type="text"
                placeholder="Search by name, student ID, or grade"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  flex: 1,
                  padding: 14,
                  fontSize: 16,
                  borderRadius: 6,
                  border: "1px solid #cbd5e1",
                  marginRight: 12,
                  background: "#fff",
                }}
              />
              <button
                style={{
                  background: "#2563eb",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  fontSize: 18,
                  padding: "12px 32px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Search
              </button>
            </div>

            {/* Filters: Reason + Support Status */}
            <FiltersBar
              reasonOpen={reasonOpen}
              setReasonOpen={setReasonOpen}
              supportOpen={supportOpen}
              setSupportOpen={setSupportOpen}
              gradeOpen={gradeOpen}
              setGradeOpen={setGradeOpen}
              selectedReasons={selectedReasons}
              setSelectedReasons={setSelectedReasons}
              selectedSupports={selectedSupports}
              setSelectedSupports={setSelectedSupports}
              selectedGrades={selectedGrades}
              setSelectedGrades={setSelectedGrades}
              gradeOptions={gradeOptions}
            />

            {/* Table view */}
            {tab === "table" && (
              <>
                <div
                  style={{
                    background: "#fff",
                    borderRadius: 10,
                    marginTop: 18,
                    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                    overflow: "hidden",
                  }}
                >
                  {loading ? (
                    <div style={{ padding: 32, textAlign: "center" }}>
                      Loading students...
                    </div>
                  ) : error ? (
                    <div
                      style={{
                        padding: 32,
                        textAlign: "center",
                        color: "#ef4444",
                      }}
                    >
                      {error}
                    </div>
                  ) : (
                    <table
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead style={{ background: "#f1f5f9" }}>
                        <tr>
                          <th style={{ textAlign: "left", padding: 16 }}>
                            Name
                          </th>
                          <th style={{ textAlign: "left", padding: 16 }}>
                            Grade
                          </th>
                          <th style={{ textAlign: "left", padding: 16 }}>
                            Reason
                          </th>
                          <th style={{ textAlign: "left", padding: 16 }}>
                            Support Status
                          </th>
                          <th style={{ textAlign: "left", padding: 16 }}>
                            Last Meeting
                          </th>
                          <th style={{ textAlign: "left", padding: 16 }}>
                            Total Notes
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginated.length === 0 ? (
                          <tr>
                            <td
                              colSpan={6}
                              style={{ padding: 32, textAlign: "center" }}
                            >
                              No students found.
                            </td>
                          </tr>
                        ) : (
                          paginated.map((s, i) => (
                            <tr
                              key={s.studentId || i}
                              style={{
                                borderTop:
                                  i === 0 ? "none" : "1px solid #e5e7eb",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                navigate(`/students/${s.studentId}`)
                              }
                            >
                              <td style={{ padding: 16 }}>
                                {s.firstName || s.name} {s.lastName || ""}
                              </td>
                              <td style={{ padding: 16 }}>{s.grade}</td>
                              <td style={{ padding: 16 }}>
                                {normalizeReason(s.referredReason)}
                              </td>
                              <td style={{ padding: 16 }}>
                                {(() => {
                                  const arr = normalizeSupports(
                                    s.studentSupportStatus
                                  );
                                  return Array.isArray(arr)
                                    ? arr.join(", ")
                                    : String(arr || "-");
                                })()}
                              </td>
                              <td style={{ padding: 16 }}>
                                {getLastMeeting(s)}
                              </td>
                              <td style={{ padding: 16 }}>
                                {noteCounts[s.studentId] || 0}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  )}
                </div>

                {/* Pagination */}
                {filteredStudents.length > studentsPerPage && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 16,
                      marginTop: 24,
                    }}
                  >
                    <button
                      onClick={() => setPage(page - 1)}
                      disabled={page === 1}
                      style={{
                        padding: "8px 18px",
                        borderRadius: 6,
                        border: "none",
                        background: page === 1 ? "#e5e7eb" : "#2563eb",
                        color: page === 1 ? "#888" : "#fff",
                      }}
                    >
                      ← Prev
                    </button>
                    <span>
                      Page {page} of{" "}
                      {Math.ceil(filteredStudents.length / studentsPerPage)}
                    </span>
                    <button
                      onClick={() => setPage(page + 1)}
                      disabled={
                        page ===
                        Math.ceil(filteredStudents.length / studentsPerPage)
                      }
                      style={{
                        padding: "8px 18px",
                        borderRadius: 6,
                        border: "none",
                        background:
                          page ===
                          Math.ceil(filteredStudents.length / studentsPerPage)
                            ? "#e5e7eb"
                            : "#2563eb",
                        color:
                          page ===
                          Math.ceil(filteredStudents.length / studentsPerPage)
                            ? "#888"
                            : "#fff",
                      }}
                    >
                      Next →
                    </button>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
